import { useCallback, useEffect } from "react";
import { useEntities } from "cityads-v3/hooks/entities";
import { usePaginator } from "cityads-v3/hooks/paginator";
import { useScrollToTop } from "cityads-v3/hooks/utils";
import { BannerRotatorList } from "cityads-v3/types/bannerRotator";
import { Offer } from "cityads-v3/types/offers";

export function useBannerRotatorList(offerId: Offer['id']) {
  const paginator = usePaginator('bannerRotatorTool');
  const scrollToTop = useScrollToTop();
  const [page, perpage, setPage] = paginator;

  const bannerRotatorTools = useEntities<BannerRotatorList>('bannerRotatorTool');
  const [, , , loadBannerRotatorTools] = bannerRotatorTools

  const reload = useCallback(() => {
    loadBannerRotatorTools({
      page,
      perpage,
      offer_ids: [offerId],
      sort: 'added_at',
      sort_asc: false
    })
    scrollToTop()
  }, [
    loadBannerRotatorTools,
    offerId,
    page,
    perpage,
    scrollToTop
  ])

  useEffect(reload, [reload])

  /** сброс пагинации при уходе со страницы */
  useEffect(() => () => {
    setPage({}, 1)
  }, [setPage])

  return {
    bannerRotatorTools,
    paginator,
    reload
  }
}
